import React, { useState, useEffect } from "react";
import ModalHeader from "../../../components/ui/ModalHeader";
import { SelectField } from "../../../components/common/SelectField";
import { InputField } from "../../../components/common/InputField";
import UploadedBanner from "../../../components/common/UploadBanner";
import { SinglePlanOverviewModalConfigInput } from "../../../config/singleWorkout";
import { useMediaStore } from "../../../store";
import { SearchableSelectField } from "../../../components/common/SearchableSelectField";

const SinglePlanOverviewModal = ({
  jsonData,
  onOpenModal,
  onClose,
  planData,
  selectedPlanId,
  handleImageUrlChange,
  handleVideoUrlChange,
  imageUrl,
  videoUrl,
}) => {
  const { imageUrls: bannerOptions, videoUrls: videoOptions } = useMediaStore();

  const [formData, setFormData] = useState({
    plan_name: "",
    duration: "",
    level: "",
    location: "",
    trainingType: "",
    description: "",
    banner_image: "",
    plan_video: "",
  });

  useEffect(() => {
    const data = selectedPlanId ? planData : jsonData;
    if (data) {
      setFormData({
        plan_name: data?.plan_name || data?.workout_name || "",
        duration: data.estimated_duration || "",
        level: data.level || "",
        location: data.location || "",
        trainingType: data.training_type || "",
        description: data.description || "",
        banner_image: data.banner_image || imageUrl || "",
        plan_video: data.workout_video || videoUrl || "",
      });
    }
  }, [selectedPlanId, planData, jsonData, imageUrl, videoUrl]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));

    if (key === "banner_image") {
      handleImageUrlChange(value);
    } else if (key === "workout_video") {
      handleVideoUrlChange(value);
    }
  };

  const handleSelectChange = (key, value) => {
    handleChange(key, value);
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ display: "block" }}
        aria-modal="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <ModalHeader onClose={onClose} />
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-6">
                  <h5>Plan Overview</h5>
                  {SinglePlanOverviewModalConfigInput.map((field, index) =>
                    field.id === "bannerImageUrl" || field.id === "videoUrl" ? ( 
                    <>
                      <SearchableSelectField
                        key={index}
                        label={field.label}
                        id={field.id}
                        options={
                          field.id === "bannerImageUrl"
                            ? bannerOptions
                            : videoOptions
                        }
                        value={formData[field.valueKey]}
                        disabled={field.disabled}
                        onChange={(value) =>
                          handleSelectChange(field.valueKey, value)
                        }
                      />
                      
                       </>
                    ) : field.type === "select" ? (
                      <SelectField
                        key={index}
                        label={field.label}
                        id={field.id}
                        options={field.options}
                        value={formData[field.valueKey]}
                        onChange={(e) =>
                          handleChange(field.valueKey, e.target.value)
                        }
                        disabled={field.disabled}
                      />
                    ) : field.type === "textarea" ? (
                      <div className="mb-3" key={index}>
                        <label htmlFor={field.id} className="form-label">
                          {field.label}
                        </label>
                        <textarea
                          className="form-control"
                          id={field.id}
                          rows={field.rows}
                          value={formData[field.valueKey]}
                          disabled={field.disabled}
                        />
                      </div>
                    ) : (
                      <InputField
                        key={index}
                        label={field.label}
                        type={field.type}
                        id={field.id}
                        value={formData[field.valueKey]}
                        onChange={(e) =>
                          handleChange(field.valueKey, e.target.value)
                        }
                        disabled={field.disabled}
                      />
                    )
                  )}

                 

                 
                </div>

                <div className="col-sm-6">
                  <UploadedBanner defaultImage={formData.banner_image} />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={onOpenModal}
                aria-label="Save and proceed to the next step"
              >
                Save & Next
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
};

export default SinglePlanOverviewModal;
